import React from "react";
import { courses } from "./content/courses";

export default function AllCourses() {
  return(
    <section id="popular-courses" className="courses">
    <div className="container aos-init aos-animate" data-aos="fade-up">

      <div className="section-title">
        <h2>Courses</h2>
        <p>Popular Courses
        <div className="custom-button" style={{display: "flex", flexDirection: "row-reverse", color: "white"}}>
        </div>
        </p>
      </div>

      <div className="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
        {courses.map((item, index) =>
        <>
        <div key={index} className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="course-item">
            {item.image && <img src={item.image} className="img-fluid" alt="..." />}
            <div className="course-content">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{item.label}</h4>
               { item.price && <p className="price">Rs. {item.price}/year</p>}
              </div>
              {item.package && <h6><b>{item.package}</b></h6>}
               { item.date && <p className="price" style={{ color: "orangered"}}>{item.date}</p>}
              <p>{item.description}</p>
              {/* <div className="trainer d-flex justify-content-between align-items-center">
              </div> */}
            </div>
          </div>
        </div> 
        <br />
        </>
        )}

      </div> 

    </div>
  </section>
  );
}